enum ChatMessageRole {
  ASSISTANT = "ASSISTANT",
  LOCAL = "LOCAL", // FE-only: e.g. an offline or failed-delivery notice, never from the server
  USER = "USER",
}

export default ChatMessageRole;
